import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'chaoskit/src/components';

import { Data, Link } from '../../../components';
import Author from '../../global/Author';
import chaosEngineeringIcon from '../../../assets/media/community-icon-chaos-engineering.svg';
import gamedaysIcon from '../../../assets/media/community-icon-gamedays.svg';
import sreIcon from '../../../assets/media/community-icon-sre.svg';

export function getTutorialCategory(categories) {
  // We're only going to display the first category chosen in the teaser
  const [category] = categories;

  if (category === 'Chaos Engineering') {
    return {
      label: category,
      icon: chaosEngineeringIcon,
    };
  }

  if (category === 'GameDays') {
    return {
      label: category,
      icon: gamedaysIcon,
    };
  }

  if (category === 'SRE') {
    return {
      label: category,
      icon: sreIcon,
    };
  }

  return {};
}

const TutorialTeaser = ({
  title,
  author,
  authorUrl,
  excerpt,
  link,
  categories,
}) => {
  const categoryMeta = getTutorialCategory(categories);

  return (
    <article className="tutorial__teaser">
      <div className="tutorial__teaser-content">
        <div className="u-flex u-flexBetween">
          {categoryMeta.icon && (
            <img
              src={categoryMeta.icon}
              alt={categoryMeta.label}
              className="tutorial__teaser-icon"
            />
          )}
          <div className="u-textRight u-ml--small">
            <Button
              url={link}
              size="xsmall"
              type="primary"
              className="tutorial__teaser-startButton"
            >
              Start
            </Button>
          </div>
        </div>
        <h4 className="u-mt--regular u-textLarge">
          <Link className="u-textHDefault u-linkUnderline" to={link}>
            {typeof title === 'string' ? <Data>{title}</Data> : title}
          </Link>
        </h4>
        <div className="u-textSmall">
          {typeof excerpt === 'string' ? <Data>{excerpt}</Data> : excerpt}
        </div>
      </div>
      <Author
        name={author}
        url={authorUrl}
        className="tutorial__teaser-author"
      />
    </article>
  );
};

TutorialTeaser.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  author: PropTypes.string,
  authorUrl: PropTypes.string,
  excerpt: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  link: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired,
};

export default TutorialTeaser;
